import iApi from '../_api.js';

const iCompetition = {
    mixins: [iApi],

    methods: {
        entityDisplayName: function (entity, results, rounds, applications, delegated_progression) {
            if (!entity) return;

            switch (entity.type) {
                case 'application':
                    return entity.application.display_name;

                case 'progression':

                    if (entity.helper_application_id) {
                        let application = this.getApplication(entity.helper_application_id, applications);
                        if (application) {
                            return application.display_name;
                        } else {
                            let delegated_progression_by_entity_helper_application_id = this.getDelegatedProgression(entity.helper_application_id, delegated_progression);
                            if (delegated_progression_by_entity_helper_application_id) {
                                return delegated_progression_by_entity_helper_application_id.application.display_name;
                            }
                        }
                    }

                    if (entity.match_progressor_key) {
                        let match = this.getMatchByKey(entity.match_progressor_key, rounds);
                        if (match)
                            return this.matchDisplayName(match, results, rounds);
                    }

                    break;

                case 'delegatedprogression':
                    let delegated_progression_by_entity_helper_application_id = this.getDelegatedProgression(entity.helper_application_id, delegated_progression);
                    return entity.delegatedprogression.title + ' - ' + (delegated_progression_by_entity_helper_application_id ? delegated_progression_by_entity_helper_application_id.application.display_name : undefined);

                case 'blank':
                    return 'N/A';
                case 'bye':
                    return 'Bye';
            }
        },

        matchDisplayName: function (match, results, rounds) {
            if (match.result) {
                let application = this.matchResult(match.result, results);
                if (application) return application.progressor_application.display_name;
            }
            if (match) return 'Winner of Round ' + match.round.position + ', Match ' + match.position;
        },

        entityScore(match, isEntityA) {
            if ('result' in match) {
                if (isEntityA) {
                    return (match.result.entityA_score.is_forfeit ? 'F' : match.result.entityA_score.score)
                }

                return (match.result.entityB_score.is_forfeit ? 'F' : match.result.entityB_score.score)
            }
        },

        entityWinner(entity, match) {
            if ('result' in match) {
                if (match.result.winner) {
                    return entity.key === match.result.winner.key;
                }
            }
        },

        getApplication(application_id, competition_applications) {
            let result = competition_applications.filter((application) => {
                return application_id == application.id;
            });
            if (result.length > 0)
                return result[0];
            return null;
        },

        getDelegatedProgression(application_id, delegated_progressions) {
            let result = delegated_progressions.filter((delegated_progression) => {
                return delegated_progression.application && (application_id == delegated_progression.application.id);
            });
            if (result.length > 0)
                return result[0];
            return null;
        },

        matchResult: function (match_result, results) {
            if (match_result && results) {
                let result = results.filter((result) => {
                    return (match_result.competitionresult_id == result.id);
                });
                if (result.length > 0 && result[0].progressor_application) {
                    return result[0];
                }
            }
        },

        getCompetition(competition_id, complete_fn) {
            let competition = null;

            jQuery.when(
                this.callApi('GET', '/competitions/' + competition_id, null, function (result) {
                    competition = result;
                })
            ).then(function () {
                return complete_fn(competition, []);
            });
        },

        getRoundEvent(round, complete_fn) {
            if (!round) return;

            let event = null;
            let event_id = round.event_id;

            if (event_id) {
                jQuery.when(
                    this.callApi('GET', '/events/' + event_id, null, function (result) {
                        event = result;
                    }),
                ).then(function () {
                    return complete_fn(event);
                });
            }
        },

        getRoundsFromCompetition(competition) {
            let comp_version = JSON.parse(competition.latest_version.competition_serialised);

            let rounds = null;
            if ('rounds' in comp_version) {
                rounds = comp_version.rounds;
            }

            return rounds;
        },

        getPoolByProgressorKey(key, competition_id, rounds = null) {
            let result = null;

            if (!rounds) rounds = this.getRoundsFromCompetition(this.getCompetition(competition_id));

            rounds.forEach((round) => {
                round.pools.forEach((pool) => {
                    if (pool.pool_progressors.filter((progressor) => progressor.key === key).length > 0)
                        result = pool;
                })
            });

            return result;
        },

        getMatchByKey(key, rounds = null) {
            let result = null;

            if (rounds) {
                rounds.forEach((round) => {
                    round.matches.forEach((match) => {
                        if (match.key === key) result = match;
                    });
                });
            }

            return result;
        },

        getPoolByKey(key, rounds = null) {
            let result = null;

            if (rounds) {
                rounds.forEach((round) => {
                    round.pools.forEach((pool) => {
                        if (pool.key === key) result = pool;
                    });
                });
            }

            return result;
        },
    }
};

export default iCompetition;
